// export type TabName = "Compose Email" | "Email Templates" | "Email History";

export type TemplateCategory = "Onboarding" | "Marketing" | "Notifications";

export interface Template {
  id: number;
  category: TemplateCategory;
  subject: string;
  name: string;
  body: string;
  creator: {
    id: number;
    name: string;
  };
  description?: any;
  attachments?: any;
  created_at: string;
  updated_at: string;
}

// export const TABS: TabName[] = [
//   "Compose Email",
//   "Email Templates",
//   "Email History",
// ];

export const VARIABLES: string[] = [
  "{{first_name}}",
  "{{last_name}}",
  "{{email}}",
  // "{{user_category}}",
];

export const BADGE_MODIFIER: Record<TemplateCategory, string> = {
  Onboarding: "badge--onboarding",
  Marketing: "badge--marketing",
  Notifications: "badge--notifications",
};

export const MOCK_TEMPLATES: Template[] = [
  {
    id: 1,
    name: "Welcome Email",
    category: "Onboarding",
    subject: "Welcome to Kominiti, {{first_name}}!",
    body:
      "Hi {{first_name}}, Welcome to Kominiti! We're excited to have you on board as part of our growing community of mentors and mentees.",
    created_at: "2026-03-20",
    updated_at: "2026-03-20",
    creator: {
      id: 1,
      name: "John Doe"
    }
  },
  {
    id: 2,
    name: "Welcome Email",
    category: "Marketing",
    subject: "Welcome to Kominiti, {{first_name}}!",
    body:
      "Hi {{first_name}}, Welcome to Kominiti! We're excited to have you on board as part of our growing community of mentors and mentees.",
    created_at: "2026-03-20",
    updated_at: "2026-03-20",
     creator: {
      id: 1,
      name: "John Doe"
    }
  },
  {
    id: 3,
    name: "Welcome Email",
    category: "Notifications",
    subject: "Welcome to Kominiti, {{first_name}}!",
    body:
      "Hi {{first_name}}, Welcome to Kominiti! We're excited to have you on board as part of our growing community of mentors and mentees.",
    created_at: "2026-03-20",
    updated_at: "2026-03-20",
    creator: {
      id: 1,
      name: "John Doe"
    }
  },
  {
    id: 4,
    name: "Welcome Email",
    category: "Notifications",
    subject: "Welcome to Kominiti, {{first_name}}!",
    body:
      "Hi {{first_name}}, Welcome to Kominiti! We're excited to have you on board as part of our growing community of mentors and mentees.",
    created_at: "2026-03-20",
    updated_at: "2026-03-20",
     creator: {
      id: 1,
      name: "John Doe"
    }
  },
  {
    id: 5,
    name: "Welcome Email",
    category: "Onboarding",
    subject: "Welcome to Kominiti, {{first_name}}!",
    body:
      "Hi {{first_name}}, Welcome to Kominiti! We're excited to have you on board as part of our growing community of mentors and mentees.",
    created_at: "2026-03-20",
    updated_at: "2026-03-20",
     creator: {
      id: 1,
      name: "John Doe"
    }
  },
  {
    id: 6,
    name: "Welcome Email",
    category: "Marketing",
    subject: "Welcome to Kominiti, {{first_name}}!",
    body:
      "Hi {{first_name}}, Welcome to Kominiti! We're excited to have you on board as part of our growing community of mentors and mentees.",
    created_at: "2026-03-20",
    updated_at: "2026-03-20",
     creator: {
      id: 1,
      name: "John Doe"
    }
  },
];
